import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import React from "react";
import {inventarioResources} from "../endpoints";

class DialogCorreoTienda extends React.Component{
    constructor(props) {
        super(props);
        this.state={
            correo: '',
            rowData: props.rowData,
        }
    }
    handleChange = (event) => {
        const { name, value } = event.target;

        if (name === "correo") {
            const regexCorreo = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            const correoValido = regexCorreo.test(value);

            this.setState({
                correo: value,
                correoError: value !== "" && !correoValido
            });
        } else {
            this.setState({
                [name]: value
            });
        }
    }

    modificaCorreoTienda = ()=>{
        let folio = this.state.rowData.folio
        inventarioResources.modificarCorreoTienda(folio, this.state.correo).then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result => {
            if(result.message){
                this.props.refrescar(result.message,result.severity)
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            let result ={
                message:"Ha ocurrido un error inesperado",
                severity: "error",
                status_code: 400
            }
            this.props.refrescar(result.message,result.severity)
            console.log(error)
        });

    }
    componentDidMount() {
     
    }

    render() {
        return(
            <Dialog
                open={true}
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">Ingresar correo de la tienda</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2} alignItems="flex-end">
                        <Grid item xs={12}>
                            Correo tienda: <TextField type="email" value={this.state.correo} autoFocus={true} name="correo" 
                            error={this.state.correoError}
                            helperText={this.state.correoError ? "Ingrese un correo válido" : ""}
                            fullWidth onChange={this.handleChange}/>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="secondary" onClick={this.props.handleClose}>
                        Cancelar
                    </Button>
                    <Button disabled={!this.state.correo} variant="contained" onClick={this.modificaCorreoTienda} color="primary">
                        Guardar
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

export default DialogCorreoTienda;